<template>
  <div>
    <popup-hint hint="mashing">
      <template v-slot:breadcrumbs>
        <breadcrumbs home="Mashing">
          <template v-slot:left v-if="incompleteCount">
            <list-notification v-model="showStatus">
              <v-list-item>
                <v-icon>mdi-arrow-right-thin</v-icon>
                {{incompleteCount}} incomplete mash{{incompleteCount===1?'':'es'}}
                <v-spacer/>
                <v-btn small color="warning" @click="showStatus=false;$nextTick(() => {filters.completeStatus='0';filters.mashBillId=null;filters.from=null;filters.to=null,filters.number=''})">View</v-btn>
              </v-list-item>
            </list-notification>
          </template>

          <template v-slot:right>
            <v-menu offset-y v-if="company.permissions.includes('config.write')" :close-on-content-click="false" nudge-bottom="5" left max-width="500">
              <template v-slot:activator="{ on:prefMenu }">
                <v-tooltip bottom>
                  <template v-slot:activator="{on:tooltip}">
                    <v-icon small v-on="{...prefMenu,...tooltip}">mdi-tune-variant</v-icon>
                  </template>
                  Mashing preferences
                </v-tooltip>
              </template>
              <production-mashing-preferences/>
            </v-menu>
          </template>
        </breadcrumbs>
      </template>
      <template v-slot:top>
        All your mashes should be entered.
      </template>
    </popup-hint>

    <v-dialog v-model="showGraph" width="496">
      <component :is="graph" zoomed @close="showGraph=false" :from="graphFrom" :to="graphTo" disableTo/>
    </v-dialog>

    <purtrak-table name="mashes" objectType="mashes" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select show-expand
                   listEndPoint="mashes2" v-model="selected"
                   fields="id,date,number,mashBill{id,name},osg,fsg,ph,alc,duration,volume,value,comments,completed,lot,hasNotes"
                   totalFields="totalVolume,totalValue"
                   :totals.sync="totals"
                   :listFilters="listFilters"
                   @dblclick="mash => $router.push({name:'ProductionMashingEdit',params:{mashId:mash.id}})"
                   :item-class="mash => (mash.completed ? '' : 'warning--text')"
                   @itemExpanded="({item, value}) => expandMash(item, value)"
                   title="Mashing"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',filters.completeStatus!=null?(filters.completeStatus=='1'?'Completed':'Incomplete'):'',filters.mashBillId!=null?mashBillName:'']}"
                   download-endpoint="mashExportCSV"
                   >

      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.completeStatus=null;filters.mashBillId=null;filters.from=null;filters.to=null;filters.number=''">
          <v-list-item>
            <filter-search label="Number" v-model="filters.number"/>
          </v-list-item>
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item v-if="preferences.mashIncomplete">
            <v-autocomplete label="Completed" dense outlined :items="[{value:null,text:'All'},{divider:true},{value:'1',text:'Completed'},{value:'0',text:'Incomplete'}]" v-model="filters.completeStatus"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Mash bill" dense outlined :items="mashBills" item-text="name" item-value="id" v-model="filters.mashBillId"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.number!=''" close small class="ml-1" @click:close="filters.number=''">#: {{filters.number}}</v-chip>
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.completeStatus!=null" close small class="ml-1" @click:close="filters.completeStatus=null">{{filters.completeStatus=='1'?'Completed':'Incomplete'}}</v-chip>
          <v-chip v-show="filters.mashBillId!=null" close small class="ml-1" @click:close="filters.mashBillId=null">{{mashBillName}}</v-chip>
        </template>
      </template>
      <template v-slot:menu>
        <template v-if="!readOnly">
          <v-list-item :to="{name:'ProductionMashingEditNew'}"><v-list-item-title>Create mash</v-list-item-title></v-list-item>
          <v-divider/>
        </template>
        <v-list-item :to="{name:'ProductionMashingMashBills'}"><v-list-item-title>Mash bills</v-list-item-title></v-list-item>
        <v-menu :nudge-left="220" v-if="!$vuetify.breakpoint.mobile">
          <template v-slot:activator="{on:reports}">
            <v-list-item v-on="reports">
              <v-list-item-title>Reports and graphs</v-list-item-title>
              <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
            </v-list-item>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Mashing',to:{name:'ProductionMashing'}}]},query:{to:'reports/production/ReportsMashingActivity'}}">
              <v-list-item-title>Mashing activity</v-list-item-title>
              <v-list-item-action-text>Report</v-list-item-action-text>
            </v-list-item>
            <v-divider/>
            <v-list-item @click="getGraph('DashboardMashSummary')">
              <v-list-item-title>Mashing rate</v-list-item-title>
              <v-list-item-action-text>Graph</v-list-item-action-text>
            </v-list-item>
            <v-list-item @click="getGraph('DashboardMashHistory')">
              <v-list-item-title>Mashing history</v-list-item-title>
              <v-list-item-action-text>Graph</v-list-item-action-text>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-menu offset-y top>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch commands</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="printMashBatch()"><v-list-item-title>Print</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="deleteMultiple=true;showDelete=true"><v-list-item-title>Delete</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:item.date="{item,value,printing}">
        {{value | formatDateTime}}
        <div v-if="!item.completed && !printing" class="text-caption"><em>INCOMPLETE</em></div>
      </template>
      <template v-slot:item.mashBill.name="{item,printing}">
        {{item.mashBill ? item.mashBill.name : ''}}
        <div v-if="!printing" class="text-caption">{{item.comments}}</div>
      </template>
      <template v-slot:item.lot="{item,value,printing}">
        <template v-if="printing">{{value}}</template>
        <v-hover v-else-if="item.lot" v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:[{text:'Mashing',to:{name:'ProductionMashing'}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:1}})"
             :class="{'text-decoration-underline':hover}">{{item.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:item.duration="{value}">
        {{value | duration}}
      </template>
      <template v-slot:item.volume="{value}">
        {{value | number(0)}}
      </template>
      <template v-slot:item.value="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.alc="{value}">
        {{value | number(1)}}%
      </template>
      <template v-slot:item.ph="{value}">
        {{value | number(1)}}
      </template>
      <template v-slot:item.fsg="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:item.osg="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'ProductionMashingEditNew'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:header.notes>
        <v-icon>mdi-history</v-icon>
      </template>
      <template v-slot:item.notes="{item}">
        <v-btn icon :color="item.hasNotes?'green':'grey lighten-2'" small @click="mash=item;showNotes=true"><v-icon>mdi-history</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Mash operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item :to="{name:'ProductionMashingEdit',params:{mashId:item.id}}"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item @click="printMash(item.id, null, true)"><v-list-item-title>Print</v-list-item-title></v-list-item>
            <v-divider/>
            <v-list-item @click="mash=item;showNotes=true"><v-list-item-title>Mash notes</v-list-item-title></v-list-item>
            <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Mashing',to:{name:'ProductionMashing'}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:1}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="setFsg(item)"><v-list-item-title>Final {{preferences.mashBrix?'brix':'specific gravity'}}</v-list-item-title></v-list-item>
              <v-divider/>
              <v-list-item @click="updateComments(item)"><v-list-item-title>Update comments</v-list-item-title></v-list-item>
              <v-list-item @click="mash=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete mash</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='volume'">
              {{totals.totalVolume | number(0)}}
            </td>
            <td class="text-right" v-else-if="header.value==='value' && values">
              {{totals.totalValue | currency}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers,item }">
        <td :colspan="headers.length">
          <v-card class="my-4" :class="expansionPanelClass">
          <v-container>
            <v-row dense>
              <v-col cols="6">
                <v-simple-table dense class="pl-4 text-caption" :class="expansionPanelClass" style="width:100%">
                  <thead>
                    <tr>
                      <th :class="expansionPanelClass" width="40%">Item</th>
                      <th :class="expansionPanelClass" width="10%">Lot</th>
                      <th class="text-right" :class="expansionPanelClass" width="30%">{{item.completed?'':'Pending '}}Quantity</th>
                      <th class="text-right" :class="expansionPanelClass" width="20%" v-if="values && item.completed">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(mashItem,index) of item.items" :key="index">
                      <td class="text-caption">{{mashItem.itemName}}</td>
                      <td class="text-caption">
                        <a @click="$router.push({name:'ReportsView',params:{back:[{text:'Mashing',to:{name:'ProductionMashing'}}]},query:{to:'reports/inventory/ReportsLot',id:mashItem.itemId,lot:mashItem.lot,forward:0}})">{{mashItem.itemType === 'Item' ? mashItem.lot : ''}}</a>
                      </td>
                      <td class="text-caption text-right">{{mashItem.quantity | number(mashItem.itemPrecision)}} {{mashItem.itemUnits}}</td>
                      <td class="text-caption text-right" v-if="values && item.completed">{{mashItem.value | currency}}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
              <v-col cols="1"/>
              <v-col cols="5">
                <v-simple-table dense class="pl-4 text-caption" :class="expansionPanelClass" style="width:100%">
                  <thead>
                    <tr>
                      <th :class="expansionPanelClass" width="50%">Fermenter</th>
                      <th class="text-right" :class="expansionPanelClass" width="30%">{{item.completed?'':'Pending '}}Volume</th>
                      <th class="text-right" :class="expansionPanelClass" width="20%" v-if="values && item.completed">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="fermenter of item.fermenters" :key="fermenter.fermenterId">
                      <td class="text-caption">{{fermenter.fermenterName}}</td>
                      <td class="text-caption text-right">{{fermenter.volume | number(0)}} litres</td>
                      <td class="text-caption text-right" v-if="values && item.completed">{{fermenter.value | currency}}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
          </v-card>
        </td>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected mashes':'this mash'" @delete="performDelete(mash.id)"/>
    <component :is="dialog" v-bind="dialogProperties" @done="dialog = null"/>

    <v-dialog v-model="setFSG" persistent max-width="300">
      <v-card>
        <v-card-title>Final {{preferences.mashBrix ? 'brix' : 'specific gravity'}}</v-card-title>
        <v-divider/>
        <v-card-text class="pb-0 pt-2">
          <v-form ref="fsg">
            <v-container>
              <v-row>
                <v-col cols="8" v-if="preferences.mashBrix">
                  <decimal-number-input label="Final Brix" v-model="fsg" prefix="" suffix="°Bx" :precision="1" :max="100"/>
                </v-col>
                <v-col cols="8" v-else>
                  <decimal-number-input label="Final specific gravity" v-model="fsg" prefix="" suffix="" :precision="3"  :max="1.9"/>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="setFSG=false">Cancel</v-btn>
          <v-btn color="primary" @click="saveFSG">Set</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <production-mashing-notes :mashId="mash.id" v-model="showNotes" :hasNotes.sync="mash.hasNotes"/>
  </div>
</template>

<script>
import googleCharts from '@/mixins/googleCharts'
import performDelete from '@/mixins/performDelete'
import {format,add} from 'date-fns'
import ProductionMashingNotes from '@/views/production/mashing/ProductionMashingNotes'
import productionMashingPrintMash from '@/views/production/mashing/productionMashingPrintMash'
import ProductionMashingPreferences from '@/views/production/mashing/ProductionMashingPreferences'

export default {
  name: 'ProductionMashing',
  mixins: [productionMashingPrintMash,googleCharts,performDelete],
  components: {ProductionMashingNotes,ProductionMashingPreferences},
  props: {
    mashBillId: {type:String, required:false, default:null}
  },
  data() {
    return {
      incompleteCount: 0,
      showStatus: false,
      filters: {
        number: '',
        from: null,
        to: null,
        completeStatus: null,
        mashBillId: this.mashBillId,
      },
      dateDisplay: '',
      preferences: {},
      mash: {},
      completeOptions: [{name:'Completed/Incomplete',value:0},{divider:true},{name:'Completed only',value:1},{name:'Incomplete only',value:2}],
      mashBills: [{name:'All mash bills',id:null},{name:'No mash bill',id:''},{divider:true}],
      totals: {totalValue:0, totalVolume:0},
      showDelete: false,
      deleteMultiple: false,
			dialog: null,
      dialogProperties: {},
      setFSG: false,
      fsg: 0,
      showNotes: false,
      graphFrom: '',
      graphTo: '',
      graph: null,
      showGraph: false,
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'number', visible:true},
                       { value: 'notes', visible:true,excludeFromExport:true},
                       { value: 'mashBill.name', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'duration' ,visible:false},
                       { value: 'lot', visible:true},
                       { value: 'fsg', visible:false},
                       { value: 'osg', visible:false},
                       { value: 'alc', visible:true},
                       { value: 'ph', visible:false},
                       { value: 'volume', visible:true},
                       { value: 'value', visible:true}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: '#', value: 'number', width:'10%',sortable:true},
                { text: 'NOTES', value: 'notes', width:'5%',sortable:false,align:'center',print:false},
                { text: 'MASH BILL', value: 'mashBill.name', width:'25%',sortable:true},
                { text: 'COMMENTS', value: 'comments', width:'10%',sortable:true},
                { text: 'DURATION', value: 'duration', width:'10%',sortable:true, omit:() => !this.preferences.mashDuration},
                { text: 'LOT', value: 'lot', width:'10%',sortable:true},
                { text: 'FSG', value: 'fsg', width:'10%',sortable:true,align:'right'},
                { text: 'OSG', value: 'osg', width:'10%',sortable:true,align:'right'},
                { text: 'ALC', value: 'alc', width:'10%',sortable:true,align:'right'},
                { text: 'PH', value: 'ph', width:'10%',sortable:true,align:'right'},
                { text: 'LITRES', value: 'volume', width:'15%',align:'right',sortable:true},
                { text: 'VALUE', value: 'value', width:'15%',sortable:true,align:'right', omit:() => !this.values}],

    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    values() {
      return this.company.permissions.includes('values');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    mashBillName() {
      return this.mashBills.find(mashBill => mashBill.id === this.filters.mashBillId)?.name;
    },
    listFilters() {
      const filters = [];
      if (this.filters.number)
        filters.push({field:'number', comparator:'contains', value:this.filters.number});
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.completeStatus == '1' || this.filters.completeStatus == '0')
        filters.push({field:'completed', comparator:'eq', value:this.filters.completeStatus == '1' ? 'true' : 'false'});
      if (this.filters.mashBillId === '')
        filters.push({field:'noMashBill', comparator:'eq', value:''});
      else if (this.filters.mashBillId !== null)
        filters.push({field:'mashBillId', comparator:'eq', value:this.filters.mashBillId});
      return filters;
    }
  },
  async created() {
    this.$store.dispatch('checkTasks');
    this.loading = true;
    this.$lazyListLoad(this.mashBills, 'mashBills2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    const results = await this.$apiCall(`query ProductionMashing {
                                              mashingPreferences {
                                                mashBrix,mashDuration,mashIncomplete
                                              }
                                            }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.mashingPreferences;
    await this.getStatus();
    this.graphTo = format(new Date(), 'yyyy-MM-dd');
    this.graphFrom = format(add(new Date(), {years:-2}), 'yyyy-MM-dd');
    this.loading = false;

    if (!['ProductionMashingEdit', 'ProductionMashingEditNew','ProductionMashingMashBills'].includes(this._previousRoute) &&
        Object.keys(this.$route.query).length === 0 &&
        this.incompleteCount && !localStorage.getItem('hideNotification')) {
      this.$nextTick(() => this.showStatus = true);
      setTimeout(() => this.showStatus = false, 10_000);  // Close in 10 seconds
    }
  },
  methods: {
    async getStatus() {
      const results = await this.$apiCall(`query ProductionMashing {
                                             mashesIncomplete
                                          }`);
      if (!results.error)
        this.incompleteCount = results.data.mashesIncomplete;
    },
    async getGraph(name) {
      await this.loadGoogleCharts();
      this.graph = () => import(`@/views/dashboard/${name}`);
      this.showGraph = true;
    },

    async expandMash(item, value) {
      if (value && !item.items) {
        this.loading = true;
        const results = await this.$apiCall(`query ProductionMashing($id:ID!) {
                                                  mash(id:$id) {
                                                    items{itemName,itemId,itemType,quantity,itemUnits,itemPrecision,value,lot},
                                                    fermenters{fermenterId,fermenterName,volume,value}
                                                  }
                                                }`,
                                            {id:item.id});
        this.$set(item, 'items', results.data.mash.items);
        this.$set(item, 'fermenters', results.data.mash.fermenters);
        this.loading = false;
      }
    },

    updateComments(mash) {
      this.dialogProperties = {item:mash, operation:'mashUpdateComments'};
      this.dialog = () => import(`@/views/production/ProductionUpdateComments`);
    },
    setFsg(mash) {
      this.mash = mash;
      this.fsg = this.preferences.mashBrix ? this.$roundNumber((((182.4601 * mash.fsg -775.6821) * mash.fsg +1262.7794) * mash.fsg -669.5622), 1) : mash.fsg;
      this.setFSG = true;
    },
    async saveFSG() {
      if (!this.$refs.fsg.validate())
        return;
      const fsg = this.preferences.mashBrix ? this.$roundNumber((this.fsg / (258.6-((this.fsg / 258.2)*227.1))) + 1, 3) : this.fsg;
      const results = await this.$apiCall(`mutation ProductionMashing($id: ID!, $fsg:Float!) {
                                              mashSetFSG(id:$id, fsg:$fsg) {
                                                fsg,alc
                                              }
                                            }`,
                                            {id:this.mash.id,fsg});
      if (!results.error) {
        this.mash.fsg = results.data.mashSetFSG.fsg;
        this.mash.alc = results.data.mashSetFSG.alc;
        this.setFSG = false;
      }
    },

    async printMashBatch() {
      const lines = [];
      let n = this.selected.length;
      for (const mash of this.selected) {
        lines.push(... await this.printMash(mash.id, null, false));
        if (--n)
          lines.push(`<div class="page-break"/>`);
      }
      this.printHtml('Mash', lines.join(''));
    }
  }
}
</script>